(function (f) {
  if (typeof exports === "object" && typeof module !== "undefined") {
    module.exports = f();
  } else if (typeof define === "function" && define.amd) {
    define([], f);
  } else {
    var g;

    if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }

    g.OpenAPISampler = f();
  }
})(function () {
  var define, module, exports;
  return function e(t, n, r) {
    function s(o, u) {
      if (!n[o]) {
        if (!t[o]) {
          var a = typeof require == "function" && require;
          if (!u && a) return a(o, !0);
          if (i) return i(o, !0);
          var f = new Error("Cannot find module '" + o + "'");
          throw f.code = "MODULE_NOT_FOUND", f;
        }

        var l = n[o] = {
          exports: {}
        };
        t[o][0].call(l.exports, function (e) {
          var n = t[o][1][e];
          return s(n ? n : e);
        }, l, l.exports, e, t, n, r);
      }

      return n[o].exports;
    }

    var i = typeof require == "function" && require;

    for (var o = 0; o < r.length; o++) {
      s(r[o]);
    }

    return s;
  }({
    1: [function (require, module, exports) {
      var hasOwn = Object.prototype.hasOwnProperty;
      var toString = Object.prototype.toString;

      module.exports = function forEach(obj, fn, ctx) {
        if (toString.call(fn) !== '[object Function]') {
          throw new TypeError('iterator must be a function');
        }

        var l = obj.length;

        if (l === +l) {
          for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
          }
        } else {
          for (var k in obj) {
            if (hasOwn.call(obj, k)) {
              fn.call(ctx, obj[k], k, obj);
            }
          }
        }
      };
    }, {}],
    2: [function (require, module, exports) {
      'use strict';

      var each = require('foreach');

      module.exports = api;
      /**
       * Convenience wrapper around the api.
       * Calls `.get` when called with an `object` and a `pointer`.
       * Calls `.set` when also called with `value`.
       * If only supplied `object`, returns a partially applied function, mapped to the object.
       *
       * @param {Object} obj
       * @param {String|Array} pointer
       * @param value
       * @returns {*}
       */

      function api(obj, pointer, value) {
        // .set()
        if (arguments.length === 3) {
          return api.set(obj, pointer, value);
        } // .get()


        if (arguments.length === 2) {
          return api.get(obj, pointer);
        } // Return a partially applied function on `obj`.


        var wrapped = api.bind(api, obj); // Support for oo style

        for (var name in api) {
          if (api.hasOwnProperty(name)) {
            wrapped[name] = api[name].bind(wrapped, obj);
          }
        }

        return wrapped;
      }
      /**
       * Lookup a json pointer in an object
       *
       * @param {Object} obj
       * @param {String|Array} pointer
       * @returns {*}
       */


      api.get = function get(obj, pointer) {
        var refTokens = Array.isArray(pointer) ? pointer : api.parse(pointer);

        for (var i = 0; i < refTokens.length; ++i) {
          var tok = refTokens[i];

          if (!(typeof obj == 'object' && tok in obj)) {
            throw new Error('Invalid reference token: ' + tok);
          }

          obj = obj[tok];
        }

        return obj;
      };
      /**
       * Sets a value on an object
       *
       * @param {Object} obj
       * @param {String|Array} pointer
       * @param value
       */


      api.set = function set(obj, pointer, value) {
        var refTokens = Array.isArray(pointer) ? pointer : api.parse(pointer),
            nextTok = refTokens[0];

        for (var i = 0; i < refTokens.length - 1; ++i) {
          var tok = refTokens[i];

          if (tok === '-' && Array.isArray(obj)) {
            tok = obj.length;
          }

          nextTok = refTokens[i + 1];

          if (!(tok in obj)) {
            if (nextTok.match(/^(\d+|-)$/)) {
              obj[tok] = [];
            } else {
              obj[tok] = {};
            }
          }

          obj = obj[tok];
        }

        if (nextTok === '-' && Array.isArray(obj)) {
          nextTok = obj.length;
        }

        obj[nextTok] = value;
        return this;
      };
      /**
       * Removes an attribute
       *
       * @param {Object} obj
       * @param {String|Array} pointer
       */


      api.remove = function (obj, pointer) {
        var refTokens = Array.isArray(pointer) ? pointer : api.parse(pointer);
        var finalToken = refTokens[refTokens.length - 1];

        if (finalToken === undefined) {
          throw new Error('Invalid JSON pointer for remove: "' + pointer + '"');
        }

        var parent = api.get(obj, refTokens.slice(0, -1));

        if (Array.isArray(parent)) {
          var index = +finalToken;

          if (finalToken === '' && isNaN(index)) {
            throw new Error('Invalid array index: "' + finalToken + '"');
          }

          Array.prototype.splice.call(parent, index, 1);
        } else {
          delete parent[finalToken];
        }
      };
      /**
       * Returns a (pointer -> value) dictionary for an object
       *
       * @param obj
       * @param {function} descend
       * @returns {}
       */


      api.dict = function dict(obj, descend) {
        var results = {};
        api.walk(obj, function (value, pointer) {
          results[pointer] = value;
        }, descend);
        return results;
      };
      /**
       * Iterates over an object
       * Iterator: function (value, pointer) {}
       *
       * @param obj
       * @param {function} iterator
       * @param {function} descend
       */


      api.walk = function walk(obj, iterator, descend) {
        var refTokens = [];

        descend = descend || function (value) {
          var type = Object.prototype.toString.call(value);
          return type === '[object Object]' || type === '[object Array]';
        };

        (function next(cur) {
          each(cur, function (value, key) {
            refTokens.push(String(key));

            if (descend(value)) {
              next(value);
            } else {
              iterator(value, api.compile(refTokens));
            }

            refTokens.pop();
          });
        })(obj);
      };
      /**
       * Tests if an object has a value for a json pointer
       *
       * @param obj
       * @param pointer
       * @returns {boolean}
       */


      api.has = function has(obj, pointer) {
        try {
          api.get(obj, pointer);
        } catch (e) {
          return false;
        }

        return true;
      };
      /**
       * Escapes a reference token
       *
       * @param str
       * @returns {string}
       */


      api.escape = function escape(str) {
        return str.toString().replace(/~/g, '~0').replace(/\//g, '~1');
      };
      /**
       * Unescapes a reference token
       *
       * @param str
       * @returns {string}
       */


      api.unescape = function unescape(str) {
        return str.replace(/~1/g, '/').replace(/~0/g, '~');
      };
      /**
       * Converts a json pointer into a array of reference tokens
       *
       * @param pointer
       * @returns {Array}
       */


      api.parse = function parse(pointer) {
        if (pointer === '') {
          return [];
        }

        if (pointer.charAt(0) !== '/') {
          throw new Error('Invalid JSON pointer: ' + pointer);
        }

        return pointer.substring(1).split(/\//).map(api.unescape);
      };
      /**
       * Builds a json pointer from a array of reference tokens
       *
       * @param refTokens
       * @returns {string}
       */


      api.compile = function compile(refTokens) {
        if (refTokens.length === 0) {
          return '';
        }

        return '/' + refTokens.map(api.escape).join('/');
      };
    }, {
      "foreach": 1
    }],
    3: [function (require, module, exports) {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      exports.allOfSample = allOfSample;

      var _traverse2 = require('./traverse');

      var _utils = require('./utils');

      function allOfSample(into, children, options, spec) {
        var res = (0, _traverse2.traverse)(into, options, spec);
        var subSamples = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var subSchema = _step.value;

            var _traverse = (0, _traverse2.traverse)(_extends({
              type: type
            }, subSchema), options, spec),
                type = _traverse.type,
                readOnly = _traverse.readOnly,
                writeOnly = _traverse.writeOnly,
                value = _traverse.value;

            if (res.type && type && type !== res.type) {
              throw new Error('allOf: schemas with different types can\'t be merged');
            }

            res.type = res.type || type;
            res.readOnly = res.readOnly || readOnly;
            res.writeOnly = res.writeOnly || writeOnly;
            if (value != null) subSamples.push(value);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (res.type === 'object') {
          res.value = _utils.mergeDeep.apply(undefined, [res.value || {}].concat(subSamples));
          return res;
        } else {
          if (res.type === 'array') {
            // TODO: implement arrays
            console.warn('OpenAPI Sampler: found allOf with "array" type. Result may be incorrect');
          }

          var lastSample = subSamples[subSamples.length - 1];
          res.value = lastSample != null ? lastSample : res.value;
          return res;
        }
      }
    }, {
      "./traverse": 12,
      "./utils": 13
    }],
    4: [function (require, module, exports) {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.inferType = inferType;
      var schemaKeywordTypes = {
        multipleOf: 'number',
        maximum: 'number',
        exclusiveMaximum: 'number',
        minimum: 'number',
        exclusiveMinimum: 'number',
        maxLength: 'string',
        minLength: 'string',
        pattern: 'string',
        items: 'array',
        maxItems: 'array',
        minItems: 'array',
        uniqueItems: 'array',
        additionalItems: 'array',
        maxProperties: 'object',
        minProperties: 'object',
        required: 'object',
        additionalProperties: 'object',
        properties: 'object',
        patternProperties: 'object',
        dependencies: 'object'
      };

      function inferType(schema) {
        if (schema.type !== undefined) {
          return schema.type;
        }

        var keywords = Object.keys(schemaKeywordTypes);

        for (var i = 0; i < keywords.length; i++) {
          var keyword = keywords[i];
          var type = schemaKeywordTypes[keyword];

          if (schema[keyword] !== undefined) {
            return type;
          }
        }

        return null;
      }
    }, {}],
    5: [function (require, module, exports) {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.inferType = exports._samplers = undefined;
      exports.sample = sample;
      exports._registerSampler = _registerSampler;

      var _infer = require('./infer');

      Object.defineProperty(exports, 'inferType', {
        enumerable: true,
        get: function get() {
          return _infer.inferType;
        }
      });

      var _traverse = require('./traverse');

      var _index = require('./samplers/index');

      var _samplers = exports._samplers = {};

      var defaults = {
        skipReadOnly: false
      };

      function sample(schema, options, spec) {
        var opts = Object.assign({}, defaults, options);
        (0, _traverse.clearCache)();
        return (0, _traverse.traverse)(schema, opts, spec).value;
      }

      ;

      function _registerSampler(type, sampler) {
        _samplers[type] = sampler;
      }

      ;

      _registerSampler('array', _index.sampleArray);

      _registerSampler('boolean', _index.sampleBoolean);

      _registerSampler('integer', _index.sampleNumber);

      _registerSampler('number', _index.sampleNumber);

      _registerSampler('object', _index.sampleObject);

      _registerSampler('string', _index.sampleString);
    }, {
      "./infer": 4,
      "./samplers/index": 8,
      "./traverse": 12
    }],
    6: [function (require, module, exports) {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.sampleArray = sampleArray;

      var _traverse2 = require('../traverse');

      function sampleArray(schema) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var spec = arguments[2];
        var arrayLength = schema.minItems || 1;

        if (Array.isArray(schema.items)) {
          arrayLength = Math.max(arrayLength, schema.items.length);
        }

        var itemSchemaGetter = function itemSchemaGetter(itemNumber) {
          if (Array.isArray(schema.items)) {
            return schema.items[itemNumber] || {};
          }

          return schema.items || {};
        };

        var res = [];
        if (!schema.items) return res;

        for (var i = 0; i < arrayLength; i++) {
          var itemSchema = itemSchemaGetter(i);

          var _traverse = (0, _traverse2.traverse)(itemSchema, options, spec),
              sample = _traverse.value;

          res.push(sample);
        }

        return res;
      }
    }, {
      "../traverse": 12
    }],
    7: [function (require, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.sampleBoolean = sampleBoolean;

      function sampleBoolean(schema) {
        return true; // let be optimistic :)
      }
    }, {}],
    8: [function (require, module, exports) {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _array = require('./array');

      Object.defineProperty(exports, 'sampleArray', {
        enumerable: true,
        get: function get() {
          return _array.sampleArray;
        }
      });

      var _boolean = require('./boolean');

      Object.defineProperty(exports, 'sampleBoolean', {
        enumerable: true,
        get: function get() {
          return _boolean.sampleBoolean;
        }
      });

      var _number = require('./number');

      Object.defineProperty(exports, 'sampleNumber', {
        enumerable: true,
        get: function get() {
          return _number.sampleNumber;
        }
      });

      var _object = require('./object');

      Object.defineProperty(exports, 'sampleObject', {
        enumerable: true,
        get: function get() {
          return _object.sampleObject;
        }
      });

      var _string = require('./string');

      Object.defineProperty(exports, 'sampleString', {
        enumerable: true,
        get: function get() {
          return _string.sampleString;
        }
      });
    }, {
      "./array": 6,
      "./boolean": 7,
      "./number": 9,
      "./object": 10,
      "./string": 11
    }],
    9: [function (require, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.sampleNumber = sampleNumber;

      function sampleNumber(schema) {
        var res = void 0;

        if (schema.maximum && schema.minimum) {
          res = schema.exclusiveMinimum ? Math.floor(schema.minimum) + 1 : schema.minimum;

          if (schema.exclusiveMaximum && res >= schema.maximum || !schema.exclusiveMaximum && res > schema.maximum) {
            res = (schema.maximum + schema.minimum) / 2;
          }

          return res;
        }

        if (schema.minimum) {
          if (schema.exclusiveMinimum) {
            return Math.floor(schema.minimum) + 1;
          } else {
            return schema.minimum;
          }
        }

        if (schema.maximum) {
          if (schema.exclusiveMaximum) {
            return schema.maximum > 0 ? 0 : Math.floor(schema.maximum) - 1;
          } else {
            return schema.maximum > 0 ? 0 : schema.maximum;
          }
        }

        return 0;
      }
    }, {}],
    10: [function (require, module, exports) {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      exports.sampleObject = sampleObject;

      var _traverse = require('../traverse');

      function sampleObject(schema) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var spec = arguments[2];
        var res = {};

        if (schema && _typeof(schema.properties) === 'object') {
          var requiredKeys = Array.isArray(schema.required) ? schema.required : [];
          var requiredKeyDict = requiredKeys.reduce(function (dict, key) {
            dict[key] = true;
            return dict;
          }, {});
          Object.keys(schema.properties).forEach(function (propertyName) {
            // skip before traverse that could be costly
            if (options.skipNonRequired && !requiredKeyDict.hasOwnProperty(propertyName)) {
              return;
            }

            var sample = (0, _traverse.traverse)(schema.properties[propertyName], options, spec);

            if (options.skipReadOnly && sample.readOnly) {
              return;
            }

            if (options.skipWriteOnly && sample.writeOnly) {
              return;
            }

            res[propertyName] = sample.value;
          });
        }

        if (schema && _typeof(schema.additionalProperties) === 'object') {
          res.property1 = (0, _traverse.traverse)(schema.additionalProperties, options, spec).value;
          res.property2 = (0, _traverse.traverse)(schema.additionalProperties, options, spec).value;
        }

        return res;
      }
    }, {
      "../traverse": 12
    }],
    11: [function (require, module, exports) {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.sampleString = sampleString;

      var _utils = require('../utils');

      var passwordSymbols = 'qwerty!@#$%^123456';

      function emailSample() {
        return 'user@example.com';
      }

      function passwordSample(min, max) {
        var res = 'pa$$word';

        if (min > res.length) {
          res += '_';
          res += (0, _utils.ensureMinLength)(passwordSymbols, min - res.length).substring(0, min - res.length);
        }

        return res;
      }

      function commonDateTimeSample(min, max, omitTime) {
        var res = (0, _utils.toRFCDateTime)(new Date(), omitTime, false);

        if (res.length < min) {
          throw new Error('Using minLength = ' + min + ' is incorrect with format "date-time"');
        }

        if (max && res.length > max) {
          throw new Error('Using maxLength = ' + max + ' is incorrect with format "date-time"');
        }

        return res;
      }

      function dateTimeSample(min, max) {
        return commonDateTimeSample(min, max);
      }

      function dateSample(min, max) {
        return commonDateTimeSample(min, max, true);
      }

      function defaultSample(min, max) {
        var res = (0, _utils.ensureMinLength)('string', min);

        if (max && res.length > max) {
          res = res.substring(0, max);
        }

        return res;
      }

      function ipv4Sample() {
        return '192.168.0.1';
      }

      function ipv6Sample() {
        return '2001:0db8:85a3:0000:0000:8a2e:0370:7334';
      }

      function hostnameSample() {
        return 'example.com';
      }

      function uriSample() {
        return 'http://example.com';
      }

      var stringFormats = {
        'email': emailSample,
        'password': passwordSample,
        'date-time': dateTimeSample,
        'date': dateSample,
        'ipv4': ipv4Sample,
        'ipv6': ipv6Sample,
        'hostname': hostnameSample,
        'uri': uriSample,
        'default': defaultSample
      };

      function sampleString(schema) {
        var format = schema.format || 'default';
        var sampler = stringFormats[format] || defaultSample;
        return sampler(schema.minLength | 0, schema.maxLength);
      }
    }, {
      "../utils": 13
    }],
    12: [function (require, module, exports) {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      exports.clearCache = clearCache;
      exports.traverse = traverse;

      var _openapiSampler = require('./openapi-sampler');

      var _allOf = require('./allOf');

      var _infer = require('./infer');

      var _jsonPointer = require('json-pointer');

      var _jsonPointer2 = _interopRequireDefault(_jsonPointer);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var $refCache = {};

      function clearCache() {
        $refCache = {};
      }

      function traverse(schema, options, spec) {
        if (schema.$ref) {
          if (!spec) {
            throw new Error('Your schema contains $ref. You must provide specification in the third parameter.');
          }

          var ref = decodeURIComponent(schema.$ref);

          if (ref.startsWith('#')) {
            ref = ref.substring(1);
          }

          var referenced = _jsonPointer2.default.get(spec, ref);

          var result = void 0;

          if ($refCache[ref] !== true) {
            $refCache[ref] = true;
            result = traverse(referenced, options, spec);
            $refCache[ref] = false;
          } else {
            var referencedType = (0, _infer.inferType)(referenced);
            result = {
              value: referencedType === 'object' ? {} : referencedType === 'array' ? [] : undefined
            };
          }

          return result;
        }

        if (schema.example !== undefined) {
          return {
            value: schema.example,
            readOnly: schema.readOnly,
            writeOnly: schema.writeOnly,
            type: schema.type
          };
        }

        if (schema.allOf !== undefined) {
          return (0, _allOf.allOfSample)(_extends({}, schema, {
            allOf: undefined
          }), schema.allOf, options, spec);
        }

        if (schema.oneOf && schema.oneOf.length) {
          if (schema.anyOf) {
            console.warn('oneOf and anyOf are not supported on the same level. Skipping anyOf');
          }

          return traverse(schema.oneOf[0], options, spec);
        }

        if (schema.anyOf && schema.anyOf.length) {
          return traverse(schema.anyOf[0], options, spec);
        }

        var example = null;
        var type = null;

        if (schema.default !== undefined) {
          example = schema.default;
        } else if (schema.enum !== undefined && schema.enum.length) {
          example = schema.enum[0];
        } else {
          type = schema.type;

          if (!type) {
            type = (0, _infer.inferType)(schema);
          }

          var sampler = _openapiSampler._samplers[type];

          if (sampler) {
            example = sampler(schema, options, spec);
          }
        }

        return {
          value: example,
          readOnly: schema.readOnly,
          writeOnly: schema.writeOnly,
          type: type
        };
      }
    }, {
      "./allOf": 3,
      "./infer": 4,
      "./openapi-sampler": 5,
      "json-pointer": 2
    }],
    13: [function (require, module, exports) {
      'use strict';

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      exports.toRFCDateTime = toRFCDateTime;
      exports.ensureMinLength = ensureMinLength;
      exports.mergeDeep = mergeDeep;

      function pad(number) {
        if (number < 10) {
          return '0' + number;
        }

        return number;
      }

      function toRFCDateTime(date, omitTime, milliseconds) {
        var res = date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate());

        if (!omitTime) {
          res += 'T' + pad(date.getUTCHours()) + ':' + pad(date.getUTCMinutes()) + ':' + pad(date.getUTCSeconds()) + (milliseconds ? '.' + (date.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) : '') + 'Z';
        }

        return res;
      }

      ;

      function ensureMinLength(sample, min) {
        if (min > sample.length) {
          return sample.repeat(Math.trunc(min / sample.length) + 1).substring(0, min);
        }

        return sample;
      }

      function mergeDeep() {
        var isObject = function isObject(obj) {
          return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
        };

        for (var _len = arguments.length, objects = Array(_len), _key = 0; _key < _len; _key++) {
          objects[_key] = arguments[_key];
        }

        return objects.reduce(function (prev, obj) {
          Object.keys(obj).forEach(function (key) {
            var pVal = prev[key];
            var oVal = obj[key];

            if (isObject(pVal) && isObject(oVal)) {
              prev[key] = mergeDeep(pVal, oVal);
            } else {
              prev[key] = oVal;
            }
          });
          return prev;
        }, Array.isArray(objects[objects.length - 1]) ? [] : {});
      }
    }, {}]
  }, {}, [5])(5);
});